module.exports = __webpack_public_path__ + "img/trust.800dd109.jpeg";